import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DEFAULT_CURRENCY_CODE, ErrorHandler, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ApplicationinsightsAngularpluginErrorService } from '@microsoft/applicationinsights-angularplugin-js';
import { environment } from '@environments/environment';
import { LoggerService, AuthService, Unity4Claim } from '@adreno-common';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: ApplicationinsightsAngularpluginErrorService,
    },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'AUD' },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(title: Title, logger: LoggerService, authSvc: AuthService) {
    title.setTitle(
      `Connect${
        environment.development ? 'Dev' : environment.staging ? 'UAT' : ''
      } - Unity4`
    );
    logger.initAppInsights();
    authSvc
      .hasClaim$(Unity4Claim.VerboseLogging)
      .subscribe((hasClaim) => (logger.verboseLogging = hasClaim));
  }
}
